import { useMutation } from "@tanstack/react-query";
import { createFeedWeb } from "../../../../service/feed";

const useCreateFeedWeb = () => {
    const mutation = useMutation({
        mutationFn: createFeedWeb
    });
    return mutation;
}

export { useCreateFeedWeb }